import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {Opportunity} from '../../interfaces/opportunity.interface';
import {FollowUp} from '../../interfaces/follow-up.interface';
import {MatButton} from '@angular/material/button';



@Component({
    imports: [
        MatDialogActions,
        MatButton,
        MatDialogClose,
        MatDialogContent
    ],
    template: `
        <div mat-dialog-content style="display: flex; flex-direction: column; align-items: center; gap: 10px">
            @if (isOpportunity(entity)) {
                <span>
              Deleting opportunity <strong>{{ entity.opportunityName }}</strong>
            </span>
            }
            @if (!isOpportunity(entity)) {
                <span>
              Deleting latest follow up
            </span>
            }
            <span>Do you want to proceed?</span>
        </div>
        <div mat-dialog-actions style="display: flex; justify-content: space-between">
            <button mat-flat-button [mat-dialog-close]="false">No</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="true">Yes</button>
        </div>
    `
})
export class OpportunityDeletionDialogComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public entity: Opportunity | FollowUp
    ) {}

    isOpportunity(entity: Opportunity | FollowUp): entity is Opportunity {
        return 'opportunityName' in entity;
    }
}